var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.query.showforum)?_c('Forum'):(_vm.$route.query.showtopic)?_c('Thread'):(_vm.$route.query.act && _vm.$route.query.act == 'Members')?_c('Members'):_c('AllForums')],1)}
var staticRenderFns = []

export { render, staticRenderFns }